import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="8"
    height="4"
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.19515 3.89143C4.08737 3.99402 3.91263 3.99402 3.80485 3.89143L0.331387 0.585173C0.157527 0.419682 0.280662 0.136719 0.526536 0.136719H7.47346C7.71934 0.136719 7.84247 0.419682 7.66861 0.585172L4.19515 3.89143Z"
      fill="currentColor"
    />
  </svg>
);

const ArrowDownIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ArrowDownIcon;
